import React from "react";
import { useDispatch } from "react-redux";
import { modalUpdate } from "../../../../store/actions/settingsActions";

function CompletePackageTicket({ ticket }) {
  const dispatch = useDispatch();
  return (
    <div
      className={`home-left-content2-item item2 ${ticket.status ? "call-completed" : "call-completedMute"}`}
      onClick={() => ticket.status ? dispatch(modalUpdate({ visible: 1, content: "TrackingPackage", modalType: 1 })) : null }
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="63"
        fill="none"
        viewBox="0 0 60 63"
      >
        <circle
          cx="30.5"
          cy="17.5"
          r="14.5"
          stroke="#1BB79F"
          strokeWidth="4.287"
        />
        <path
          stroke="#1BB79F"
          strokeWidth="4.287"
          d="M3 60c0-15.464 12.088-28 27-28"
        />
        <path
          stroke="#1BB79F"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="3.131"
          d="M57 42L40.9 60 34 53.25"
        />
      </svg>
      <h4>Update</h4>
    </div>
  );
}

export default CompletePackageTicket;
